import Vue from "vue";

// axios
import axios from "axios";
let userData = localStorage.getItem("ugems-accessToken");
let token = userData ? userData : "";

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: '/api',
  // baseURL: 'http://localhost:3106/sp/api/v1',
  // baseURL: "https://api.ugems.id/sp/api/v1",
  baseURL: process.env.VUE_APP_API_URL,
  // timeout: 1000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosIns.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // if(!(router.history.current.path).includes("login") && error.response.status == 401){
    //   console.log('path is not login & status code 401');

    //   // Remove userData from localStorage
    //   localStorage.removeItem('userData')

    //   // Redirect to login page
    //   router.push({ name: 'auth-login' })
    // }
    // console.log(`error : ${error.response.status}`);
    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
